import { theme } from '@/utils/theme';

export const classes = {
  wrapper: 'pl-4 px-7 mt-1 mb-3 w-full',
  closeIcon: 'cursor-pointer mb-1',
};

export const styles = {
  input: {
    '&': {
      width: '100%',
    },
    '& .MuiFormLabel-root, & .MuiFormLabel-root:not(.Mui-focused)': {
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    '& .MuiInputBase-input::placeholder': {
      color: theme.palette['grey-6'].main,
      opacity: 1,
    },
    '.dark & .MuiInputBase-input': {
      color: theme.palette['mauve-1'].main,
    },
    '.dark & .MuiInputBase-input::placeholder': {
      color: theme.palette['mauve-3'].main,
    },
    '.dark & .MuiFilledInput-root': {
      backgroundColor: 'rgba(255,255,255,0.06)',
    },
    '.dark & .MuiFilledInput-root:hover, .dark & .MuiFilledInput-root.Mui-focused':
      {
        backgroundColor: 'rgba(255,255,255,0.09)',
      },
    '.dark & .MuiFormLabel-root': {
      color: theme.palette['mauve-2'].main,
    },
    '& .MuiInputBase-root:before': {
      border: '0px solid transparent',
    },
    '& .MuiInputBase-root': {
      paddingBottom: '0.25rem',
    },
    '& .MuiInputBase-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline':
      {
        borderColor: theme.palette['orange-3'].main,
      },
    '& .MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: `1px solid ${theme.palette['grey-5'].main}`,
    },
    '& .MuiInputBase-root.Mui-focused:after': {
      borderBottom: `2px solid ${theme.palette['orange-3'].main}`,
    },
  },
};
